import React from "react";
import ReactDom from "react-dom";
import Popup from "./popup.jsx";

export default class SaveSearchRenderer {
    constructor(container, data) {
        this._container = container;
        this._data = data;
    }

    onClose = () => {
        ReactDom.unmountComponentAtNode(this._container);
    };

    render() {
        ReactDom.render(<Popup {...this._data} onRequestClose={this.onClose} />, this._container);
    }

    destroy() {
        ReactDom.unmountComponentAtNode(this._container);
    }
}